import { FileText, X } from "lucide-react";
import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import type { RequestedDocumentInput } from "@recobra/schemas/document";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
  InputGroupText,
} from "@recobra/ui/input-group";

const REQUESTED_DOCUMENT_LABEL_MAX = 120;

/** The type says what is being asked for; the detail tells two requests of it apart. */
export const RequestedDocumentRow: FC<{
  entry: RequestedDocumentInput;
  onLabelChange: (label: string) => void;
  onRemove: () => void;
}> = ({ entry, onLabelChange, onRemove }) => {
  const detailPlaceholder =
    entry.documentType === "other"
      ? m.task_requested_documents_other_placeholder()
      : m.task_requested_documents_detail_placeholder();

  return (
    <InputGroup>
      <InputGroupAddon align="block-start">
        <FileText />
        <InputGroupText>
          {m.document_type_label({ documentType: entry.documentType })}
        </InputGroupText>
        <InputGroupButton
          size="icon-xs"
          className="ml-auto"
          aria-label={m.task_requested_documents_remove()}
          onClick={onRemove}
        >
          <X />
        </InputGroupButton>
      </InputGroupAddon>
      <InputGroupInput
        aria-label={detailPlaceholder}
        placeholder={detailPlaceholder}
        maxLength={REQUESTED_DOCUMENT_LABEL_MAX}
        value={entry.label ?? ""}
        onChange={(event) => onLabelChange(event.target.value)}
      />
    </InputGroup>
  );
};
